/* eslint-disable @typescript-eslint/no-explicit-any */
export async function sendNotifications(mboxParam: any) {
  //Check if running in browser
  if (typeof window == 'undefined') {
    return;
  }

  //Check if adobe.target is available
  if (!(window as any).adobe || !(window as any).adobe.target) {
    return;
  }

  let notifications = {};

  try {
    if (mboxParam) {
      notifications = [
        {
          id: crypto.randomUUID(),
          mbox: {
            name: mboxParam?.name,
            state: mboxParam?.state,
          },
          type: 'display',
          timestamp: Date.now(),
          tokens: [String(mboxParam?.options?.[0]?.eventToken)],
        },
      ];
    }

    const sendResponse = await (window as any).adobe.target.sendNotifications({
      request: { notifications },
    });

    // console.log('[Target] SendNotification request structure: ', notifications);
    // console.log('[Target] SendNotification Response (Empty response is normal): ', sendResponse);

    return sendResponse;
  } catch (error) {
    console.error('[Target] SendNotificaiton falied:', error);
  }
}
